/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Cash/view.blocks to change it.
import Acknowledge from './Acknowledge/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Cash({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/PaymentsTreatmentPlan/Content/TreatmentPayments/Content/Content/SetupPayment/ActiveStep/DownpaymentSetup/Pay/ChooseType/Widget/Cash"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="Cash.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Acknowledge
  viewPath={`${viewPath}/Acknowledge`}
/>
</div>
{children}
</React.Fragment>)
}